<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M10.52,15.49v-.84H2.83l-2-2.53V4.94L2.58,2.46H17.17l2,2.54v7.16l-1.73,2.49H13.55l-.23.16-2.8,2Z"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
    />
  </svg>
</template>
